import { Component, Input, AfterViewInit } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import {ProductBarcodeService} from '../../../../api/product-barcode.service';


@Component({
	selector: 'app-product-barcode-detail-view',
	templateUrl: 'product-barcode-detail-view.component.html',
	providers: [],
})
export class ProductBarcodeDetailViewComponent implements AfterViewInit {
	@Input() key: number;

	public productsData: any = {};

	constructor(
		private productBarcodeService: ProductBarcodeService,
	) {
	}

	ngAfterViewInit() {
		this.productsData = new CustomStore({
			key: 'ProductBarcodeId',
			load: (loadOptions: any) => {
				return this.productBarcodeService.getInconsistentServiceAndProductMappingForProductBarcodeAssignment(loadOptions, this.key)
					.toPromise()
					.then((data: any) => {
						return {
							data: data.data,
							totalCount: data.totalCount,
							summary: data.summary,
							groupCount: data.groupCount
						};
					})
					.catch(error => { throw new Error('Data Loading Error'); });
			}
		});
	}
}
